import { all, fork } from 'redux-saga/effects';

import listenLoad from './listenLoad';
import listenSendReview from './listenSendReview';

export default function* bookingReviewsSaga() {
  yield all([fork(listenLoad)]);
  yield all([fork(listenSendReview)]);
}
